import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

PresenceBadge.propTypes = {
    status: PropTypes.bool.isRequired
};

function PresenceBadge({status = true}) {
    if (status) {
       return <Badge rounded color={'online'}>Renseigné</Badge>
    }

    return <Badge rounded color={'error'}>Manquant</Badge>
}

export default PresenceBadge;
